const featureToggles = {
  // Allow-list of user IDs who see gated features (e.g. Cello on production).
  featureFlagOverrideUserIds: [2, 341236, 1628319],

  // Pitch limit A/B/C test: variant b = 1/day, c = 5/month.
  // Set to true when the test is ready to go live.
  pitchLimitAbcTest: true,
};

/**
 * Cello referral UI: shown in non-production Twine environments (`__CLOUD_ENV__` !== `production`)
 * for any logged-in user; on production, only for IDs in `featureFlagOverrideUserIds`.
 * (`__CLOUD_ENV__` from webpack — see scripts/utils `getCloudEnv`.)
 *
 * @param {{ id?: number|string }} [user]
 * @returns {boolean}
 */
export function showCelloReferralForUser(user) {
  if (!user || user.id == null) {
    return false;
  }
  return true;
}

export default featureToggles;
